// extracted by mini-css-extract-plugin
export var container = "navigation-module--container--Ez9L9";
export var logo = "navigation-module--logo--vgR7t";
export var logoLink = "navigation-module--logoLink--DqLte";
export var navigation = "navigation-module--navigation--kqix2";
export var navigationBullet = "navigation-module--navigationBullet--vSChA";
export var navigationItem = "navigation-module--navigationItem--0+3fY";